import React from 'react';
import { ContextSettingSelectorProps } from '../types';
import { ContextSelectorMenu } from './menu';

function UnknownSelector({ definition }: ContextSettingSelectorProps) {
  const {
    name,
    labels: { identifier },
  } = definition;
  return (
    <ContextSelectorMenu label={identifier}>
      <div className="px-6 text-ui-red py-4">
        No selector registered for <span className="font-bold">'{name}'</span>
      </div>
    </ContextSelectorMenu>
  );
}

export { UnknownSelector };
